import { createFileRoute, useParams } from "@tanstack/react-router";
import PromptTemplateEditorPage from "@/features/prompt-templates/pages/prompt-template-editor-page";

export const Route = createFileRoute("/_admin/prompt-engine/templates/$id")({
  staticData: {
    breadcrumb: { label: "Edit Template" },
  },
  component: EditRoute,
});

function EditRoute() {
  const { id } = useParams({ strict: false }) as { id: string };
  return <PromptTemplateEditorPage templateId={id} />;
}
